// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1e73e571","239":"a9546391","488":"e94c5154","667":"0efb6b53"}[chunkId] + ".chunk.js";
};